// 🔥 FINAL VERSION WITH 58+ TOGGLE

import React, { useState } from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import "bootstrap/dist/css/bootstrap.min.css";

const round = (n) => Math.round(Number(n || 0));
const cleanUAN = (val) => String(val || "").replace(/[^0-9]/g, "");
const cleanName = (val) => String(val || "").replace(/[^a-zA-Z .]/g, "");

export default function App() {
  const [employees, setEmployees] = useState([]);
  const [errors, setErrors] = useState({});

  const calculate = (row) => {
    const basic = round(row.basic || row["Gross Wages"]);
    const isAbove58 = row.isAbove58 || false;

    const eps_wages = isAbove58 ? 0 : Math.min(basic, 15000);

    return {
      ...row,
      uan: cleanUAN(row.uan || row["UAN"]),
      name: cleanName(row.name || row["Member name"]),
      basic,
      isAbove58,
      eps_wages,
      edli_wages: Math.min(basic, 15000),
      employee_epf: round(basic * 0.12),
      eps: isAbove58 ? 0 : round(eps_wages * 0.0833),
      employer_epf: isAbove58
        ? round(basic * 0.12)
        : round(basic * 0.0367),
      ncp: round(row.ncp || row["NCP Days"] || 0),
    };
  };

  const validateRow = (e) => {
    if (!/^\d{12}$/.test(e.uan)) return "Invalid UAN";
    if (!e.name) return "Name required";
    if (e.basic <= 0) return "Invalid wages";
    return null;
  };

  const processData = (data) => {
    const processed = data.map(calculate);
    const errMap = {};

    processed.forEach((row, i) => {
      const err = validateRow(row);
      if (err) errMap[i] = err;
    });

    setEmployees(processed);
    setErrors(errMap);
  };

  const handleUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onload = (evt) => {
      const data = new Uint8Array(evt.target.result);
      const wb = XLSX.read(data, { type: "array" });
      const sheet = wb.Sheets[wb.SheetNames[0]];
      const json = XLSX.utils.sheet_to_json(sheet, { defval: "" });
      processData(json);
    };

    reader.readAsArrayBuffer(file);
  };

  const updateCell = (i, key, value) => {
    const updated = [...employees];
    updated[i][key] = value;
    processData(updated);
  };

  const deleteRow = (i) => {
    processData(employees.filter((_, index) => index !== i));
  };

  const addRow = () => {
    const empty = {
      uan: "",
      name: "",
      basic: 0,
      ncp: 0,
      isAbove58: false,
    };
    processData([...employees, empty]);
  };

  const autoFix = () => {
    const fixed = employees.map((e) => ({
      ...e,
      uan: cleanUAN(e.uan),
      name: cleanName(e.name),
    }));
    processData(fixed);
  };

  const downloadTXT = () => {
    if (Object.keys(errors).length > 0) {
      alert("Fix errors first");
      return;
    }

    const rows = employees.map((e) =>
      [
        e.uan,
        e.name,
        e.basic,
        e.basic,
        e.eps_wages,
        e.edli_wages,
        e.employee_epf,
        e.employee_epf,
        e.eps,
        e.eps,
        e.employer_epf,
        e.employer_epf,
        e.ncp,
        0,
        0,
        0,
        0,
      ].join("#~#")
    );

    const content = rows.join("\n");

    const blob = new Blob([content], {
      type: "text/plain;charset=utf-8",
    });

    const month = new Date().toISOString().slice(0, 7).replace("-", "");
    saveAs(blob, `ECR_${month}.txt`);
  };

  return (
    <div className="container py-4">
      <h2 className="text-center text-primary fw-bold mb-4">
        EPFO ECR Tool ⚡
      </h2>

      <div className="d-flex gap-2 mb-3 flex-wrap">
        <input type="file" className="form-control" onChange={handleUpload} />

        <button className="btn btn-primary" onClick={addRow}>
          + Add Row
        </button>

        <button className="btn btn-warning" onClick={autoFix}>
          Auto Fix
        </button>

        <button className="btn btn-success" onClick={downloadTXT}>
          Download ECR
        </button>
      </div>

      <div className="table-responsive shadow rounded">
        <table className="table table-hover table-bordered">
          <thead className="table-dark">
            <tr>
              <th>UAN</th>
              <th>Name</th>
              <th>Basic</th>
              <th>58+</th>
              <th>EPF</th>
              <th>EPS</th>
              <th>Error</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {employees.map((e, i) => (
              <tr key={i} className={errors[i] ? "table-danger" : ""}>
                <td>
                  <input className="form-control" value={e.uan}
                    onChange={(ev) => updateCell(i, "uan", ev.target.value)} />
                </td>

                <td>
                  <input className="form-control" value={e.name}
                    onChange={(ev) => updateCell(i, "name", ev.target.value)} />
                </td>

                <td>
                  <input type="number" className="form-control" value={e.basic}
                    onChange={(ev) => updateCell(i, "basic", ev.target.value)} />
                </td>

                <td className="text-center">
                  <input type="checkbox" checked={e.isAbove58}
                    onChange={(ev) => updateCell(i, "isAbove58", ev.target.checked)} />
                </td>

                <td>{e.employee_epf}</td>
                <td>{e.eps}</td>
                <td className="text-danger">{errors[i]}</td>

                <td>
                  <button className="btn btn-sm btn-outline-danger"
                    onClick={() => deleteRow(i)}>
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
